import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import WarningArrow from '../../assets/icons/warningArrow.svg';
import styles from './ValidationWarning.css';
export const ValidationWarning = memo(function ValidationWarning({ title = '! wrong format', withArrow = true, }) {
    return (_jsxs("div", Object.assign({ "data-testid": "ValidationWarning" }, { children: [_jsx("div", Object.assign({ className: styles.validationWarning }, { children: title }), void 0), withArrow && (_jsx(WarningArrow, { className: styles.validationWarningArrow }, void 0))] }), void 0));
});
